import { useMutation, useQuery } from "react-query";
import { queryClient } from "../../../config";
import { useToast } from "../../../hooks/usetoast";
import { useNavigate } from "react-router-dom";
import DataService from '../../../config/DataServices'

const { getRequest, putRequest,postRequest } = DataService()

export const useChangePassword = () => {
    const toast = useToast();
    const navigate = useNavigate();

    return useMutation({
        mutationFn: data => {
            return putRequest("/security/change-password", { ...data })
        },
        onError: async (error) => {
           return toast.error(error?.message)  
        },
        onSuccess: async (success) => {
            sessionStorage.removeItem("apayroucarayxczijiuhxvkdsp")
            sessionStorage.removeItem('theme-dark')
            toast.success(success?.data?.message)
            return navigate('/')
        }
    })
}

export const useChangePattern = () => {
    const toast = useToast();
    const navigate = useNavigate();

    return useMutation({
        mutationFn: data => {
            return putRequest("/security/change-pattern", data)
        },
        onError: async (error) => {
            return toast.error(error?.message)  
         },
        onSuccess: success => {
            sessionStorage.removeItem("apayroucarayxczijiuhxvkdsp")
            sessionStorage.removeItem('theme-dark')
            toast.success(success?.data?.message)
            return navigate('/')
        }
    })
}

export const useGetTFASettings = () => {

    return useQuery({
        queryKey: ["get-TFA-settings"],
        queryFn: () => {
            return getRequest("/security/2fa/status")
        },
        select: res => res
    })
}

export const useTFASettings = () => {
    const toast = useToast();
    const navigate = useNavigate();

    return useMutation({
        mutationFn: data => {
            return postRequest("/security/2fa/configure", data)
        },
        onError: error => {
            return toast.error(error.message)
        },
        onSuccess: success => {
            sessionStorage.removeItem("apayroucarayxczijiuhxvkdsp")
            sessionStorage.removeItem('theme-dark')
            toast.success(success?.data?.message)
            return navigate('/')

        }
    })
}

// Profile
export const useGetProfile = () => {

    return useQuery({
        queryKey: ["get-profile"],
        queryFn: () => {
            return getRequest('/profile')
        },
        select: res => res
    })
}

export const useUpdateProfile = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: (data) => {
            return putRequest("/profile", data)
        },
        onError: error => {
            return toast.error(error?.message)
        },
        onSuccess: success => {
            queryClient.refetchQueries("faq-list");
            queryClient.refetchQueries("get-profile");
            return toast.success(success?.data?.message)
        }
    })
}